import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Card } from "react-bootstrap";
import styles from "./viewOrderPopup.module.scss";

const BaristiCalculationsModal = ({
  show,
  onHide,
  baristiData,
  freeCoffeeAdded,
}) => (
  <Modal show={show} onHide={onHide} size="md" centered>
    <Modal.Header closeButton>
      <Modal.Title>{baristiData?.title || "Baristi Calculations"}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {baristiData ? (
        <Card className="mb-0 border-0">
          <Card.Body className="p-0">
            <div className={styles.rowItem}>
              <span>Total Revenue</span>
              <span>${baristiData.totalRevenue}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Sales Tax Collected</span>
              <span>${baristiData.totalSalesTax}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Baristi Processing Fees</span>
              <span>${baristiData.totalProcessingFeesBaristi}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Stripe Processing Fees</span>
              <span>${baristiData.totalProcessingFeesStripe}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Total Commissions</span>
              <span>${baristiData.totalCommissions}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Tips</span>
              <span>${baristiData.totalTips}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Coupons Applied</span>
              <span>${baristiData.totalCouponsApplied}</span>
            </div>
            <div className={styles.rowItem}>
              <span>Free Coffee Applied</span>
              <span>
                $
                {freeCoffeeAdded
                  ? baristiData?.totalFreeCoffeeApplied || 0.0
                  : 0.0}
              </span>
            </div>
            <div className={`${styles.rowItem} mb-2`}>
              <span>
                CoffeeDrop Applied
                {baristiData.coffeeDropCampaignName
                  ? ` (${baristiData.coffeeDropCampaignName})`
                  : ""}
              </span>
              <span>${baristiData.totalCoffeeDropApplied || "0.00"}</span>
            </div>
            <hr />
            <div className={`${styles.rowItem} fw-bold`}>
              <span>Gross Profit (Baristi)</span>
              <span>${baristiData.totalGrossProfit}</span>
            </div>
            <div className={`${styles.rowItem} fw-bold text-success`}>
              <span>Net Profit (Baristi)</span>
              <span>${baristiData?.totalNetProfit}</span>
            </div>
          </Card.Body>
        </Card>
      ) : (
        <p>Loading...</p>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

BaristiCalculationsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  baristiData: PropTypes.object,
  freeCoffeeAdded: PropTypes.bool,
};

export default BaristiCalculationsModal;
